import Lottie from "lottie-react";
import TruckLoader from "../../../assets/animations/truck-loader.json";
import GeneralLoader from "../../../assets/animations/loader-section.json";
import { useEffect, useState } from "react";

const Loader = ({ type = "" }) => {
    const [loader, setLoader] = useState(null);

    useEffect(() => {
        function getLoader() {
            switch (type) {
                case "truck":
                    setLoader(TruckLoader);
                    break;
                default:
                    setLoader(GeneralLoader);
                    break;
            }
        }
        getLoader();
    }, [type]);

    return (
        <div className='w-full h-auto flex items-center justify-center'>
            <Lottie
                animationData={loader}
                loop={true}
                autoplay={true}
                className="w-96 h-96"
            />
        </div>
    );
};

export default Loader;